import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "18", y1: "16", y2: "16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Voicemail";
const Voicemail = memo(themed(Icon));
export {
  Voicemail
};
//# sourceMappingURL=voicemail.js.map
